import { parseHomePageContent } from "@site-factory/config";
import type { HomePageContent, HomepageLayoutConfig, SectionId } from "@site-factory/config";
import {
  HeroSection,
  FeaturesSection,
  ServicesSection,
  AboutSection,
  TestimonialsSection,
  ReviewsSection,
  PricingSection,
  FaqSection,
  ContactSection,
  EventsSection,
  EventBookingSection,
  CtaBarSection,
  TimelineSection,
  LocationsSection,
  NewsletterSection,
  BlogSection,
  TeamSection,
  LogoCloudSection,
} from "@site-factory/ui";
import galleryContentRaw from "../../content/gallery.json";

const content = parseHomePageContent(galleryContentRaw as HomePageContent);

const sectionComponents: Record<SectionId, React.ComponentType<any> | null> = {
  hero: HeroSection,
  features: FeaturesSection,
  services: ServicesSection,
  about: AboutSection,
  testimonials: TestimonialsSection,
  reviews: ReviewsSection,
  pricing: PricingSection,
  faq: FaqSection,
  contact: ContactSection,
  events: EventsSection,
  eventBooking: EventBookingSection,
  ctaBar: CtaBarSection,
  timeline: TimelineSection,
  locations: LocationsSection,
  newsletter: NewsletterSection,
  blog: BlogSection,
  team: TeamSection,
  logoCloud: LogoCloudSection,
};

export default function GalleryPage() {
  const layout: HomepageLayoutConfig = (content as any).layout || {
    homepageSections: [
      "hero",
      "features",
      "services",
      "about",
      "ctaBar",
      "logoCloud",
      "pricing",
      "testimonials",
      "reviews",
      "events",
      "eventBooking",
      "locations",
      "timeline",
      "faq",
      "contact",
      "newsletter",
      "blog",
      "team",
    ],
  };

  return (
    <>
      {layout.homepageSections.map((sectionId) => {
        const Component = sectionComponents[sectionId];
        const sectionContent = (content as any)[sectionId];
        if (!Component || !sectionContent) return null;
        return (
          <section key={sectionId} id={sectionId}>
            <Component {...sectionContent} />
          </section>
        );
      })}
    </>
  );
}
